import type {Color} from "@cm/graph-v3"
import type {Vec3} from "#material/types/vector"

export const cyclesColor = (color?: Color): [number, number, number] | undefined => {
    if (!color) {
        return undefined
    }
    return [color.r, color.g, color.b]
}

export const cyclesVec3 = (vector?: Vec3): [number, number, number] | undefined => {
    if (!vector) {
        return undefined
    }
    return [vector.x, vector.y, vector.z]
}

// TODO: is this the right way of dealing with null values?
export const cyclesVec3WithNullableComponents = (vector?: {x: number | null; y: number | null; z: number | null}): [number, number, number] | undefined => {
    if (!vector) {
        return undefined
    }
    return [vector.x ?? 0, vector.y ?? 0, vector.z ?? 0]
}
